import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

const classNames = {
  iconSpacer: `EditUserIconSpacer`
};

export function useEditUserStyles() {
  return useMemo(
    () => mergeStyleSets({
      iconSpacer: [
        classNames.iconSpacer,
        {
          width: `32px`,
          height: `32px`
        }
      ]
    }),
    []
  );
}
